// extracted by mini-css-extract-plugin
export var chatHtmlText = "_st-2";
export var chatLink = "_st-0";
export var chatText = "_st-1";